import React from 'react'
import { Alert, Box, Button, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import CircularProgress from '@mui/material/CircularProgress'

function ConfigurationError({
  onRetry,
  isLoading
}: {
  onRetry: () => void
  isLoading: boolean
}) {
  return (
    <Stack
      direction="column"
      spacing={4}
      sx={{
        bgcolor: 'background.paper',
        zIndex: 1000,
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 10,
        minHeight: '100vh'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: { xs: 300, sm: 400 }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: 'column',
            textAlign: 'center',
            width: '100%'
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: 'text.primary',
              mt: 2
            }}
          >
            <FormattedMessage id="page.homePage.configurationError.title" />
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              mt: 1,
              fontSize: '1.2rem',
              marginTop: '18px'
            }}
          >
            <FormattedMessage id="page.homePage.configurationError.body" />
          </Typography>
        </Box>
      </Box>
      <Alert severity="warning">
        <FormattedMessage id="page.homePage.configurationError.alert" />
      </Alert>

      {isLoading ? (
        <CircularProgress />
      ) : (
        <Button
          variant="contained"
          onClick={onRetry}
          sx={{
            marginTop: '4px'
          }}
        >
          <FormattedMessage id="page.homePage.configurationError.button" />
        </Button>
      )}
    </Stack>
  )
}

export default ConfigurationError
